"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PabloThemeProvider = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _defaultComponentStyles = require("./defaultComponentStyles");

var _defaultTheme = require("./defaultTheme");

var _context = require("./context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var overwriteMerge = function overwriteMerge(_, sourceArray) {
  return sourceArray;
};

var PabloThemeProvider = function PabloThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      _ref$componentStyles = _ref.componentStyles,
      componentStyles = _ref$componentStyles === void 0 ? {} : _ref$componentStyles,
      children = _ref.children;
  var scTheme = (0, _styledComponents.useTheme)() || {};
  var mergedTheme = (0, _deepmerge.default)(_defaultTheme.defaultTheme, theme, {
    arrayMerge: overwriteMerge
  });
  var mergedComponentStyles = (0, _deepmerge.default)(_defaultComponentStyles.defaultComponentStyles, componentStyles);
  return /*#__PURE__*/React.createElement(_context.pabloThemeContext.Provider, {
    value: mergedTheme
  }, /*#__PURE__*/React.createElement(_context.pabloComponentStylesContext.Provider, {
    value: mergedComponentStyles
  }, /*#__PURE__*/React.createElement(_styledComponents.ThemeProvider, {
    theme: _objectSpread(_objectSpread(_objectSpread({}, scTheme), mergedTheme), {}, {
      componentStyles: mergedComponentStyles
    })
  }, children)));
};

exports.PabloThemeProvider = PabloThemeProvider;